// Form Input Enums ------------------------------------------------------------------------------------------------------------------------

export enum FormInputCase {
  Lowercase = "lowercase",
  Namecase = "namecase",
  None = "none",
  Titlecase = "titlecase",
  Uppercase = "uppercase",
}

// Form Input Constants --------------------------------------------------------------------------------------------------------------------

export const FORM_INPUT_CASE_EXCEPTIONS = [
  "de la",
  "de",
  "del",
  "du",
  "el",
  "la",
  "le",
  "van der",
  "von",
];

export const FORM_INPUT_CASE_PATTERNS: FormInputCasePrefix[] = [
  { prefix: "o'", capitaliseNext: true },
  { prefix: "d'", capitaliseNext: true },
  { prefix: "mc", capitaliseNext: true, specialCase: true },
  { prefix: "mac", capitaliseNext: true, specialCase: true },
  { prefix: "st.", capitaliseNext: true },
];

// Form Input Interfaces -------------------------------------------------------------------------------------------------------------------

export interface FormInputCasePrefix {
  prefix: string;
  capitaliseNext: boolean;
  specialCase?: boolean;
}
